import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { alpha } from '@material-ui/core/styles/colorManipulator';
import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import Menu from '@material-ui/core/Menu';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
import * as Constants from '../constants'

const styles = theme => ({
  grow: {
    flexGrow: 1,
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  homeButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 10,
    marginRight: 10,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: 10,
      width: 'auto',
    },
  },
  searchIcon: {
    width: 50,
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: 10,
    paddingLeft: 50,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 170,
      '&:focus': {
        width: 400,
      },
    },
  },
});

class MainAppBar extends React.Component {
  state = {
    anchorEl: null,
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  }

  onChangeAccountData = () => {
    this.setState({ anchorEl: null });
    this.props.onChangeAccountData();
  };

  onChangePassword = () => {
    this.setState({ anchorEl: null });
    this.props.onChangePassword();
  }

  onEditReminders = () => {
    this.setState({ anchorEl: null });
    this.props.onEditReminders();
  }

  onOpenSharingManagement = () => {
    this.setState({ anchorEl: null });
    this.props.onOpenSharingManagement();
  }

  onSignOut = () => {
    this.setState({ anchorEl: null });
    this.props.onSignOut();
  }

  render() {
    const { classes, signedIn } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    return (
      <AppBar position="static">
        <Toolbar>
          <IconButton color="inherit" aria-label="Home">
            <Avatar alt={"Schemmerhofen Formulare"} src={"https://formulare-schemmerhofen.de/" + Constants.FRONTEND_SUB + "/favicon.png"} className={classes.avatar} />
          </IconButton>
          <Typography variant="h6" color="inherit" className={classes.title} noWrap>Schemmerhofen Ferienprogramm {this.props.signedIn && this.props.userData.role === "administrator" ? "- Administrator" : ""}{this.props.signedIn && this.props.userData.role === "leader" ? "- Leiter" : ""}</Typography>
          <div className={classes.grow} />
          {signedIn && this.props.serverSettings !== null && this.props.serverSettings.state > 1 && this.props.serverSettings.state < 6 && <Button color="inherit" href="https://formulare-schemmerhofen.de/files/fepro/anmeldebedingungen.pdf" target="_blank">Anmeldebedingungen</Button>}
          {signedIn && this.props.serverSettings !== null && this.props.serverSettings.state > 1 && this.props.serverSettings.state < 6 && <Button color="inherit" href="https://formulare-schemmerhofen.de/files/fepro/programmheft.pdf" target="_blank" download>Programmheft herunterladen</Button>}
          {signedIn && <div className={classes.search}>
            <div className={classes.searchIcon}><SearchIcon /></div>
            <InputBase placeholder="Programme suchen…" type="search" autoComplete="off" classes={{ root: classes.inputRoot, input: classes.inputInput }} onChange={this.props.onSearchUpdated} />
          </div>}
          {signedIn && (<div>
            <Tooltip title="Mein Account" enterDelay={500}>
              <IconButton aria-haspopup="true" onClick={this.handleMenu} color="inherit">
                <AccountCircle />
              </IconButton>
            </Tooltip>
            <Menu id="menu-appbar" anchorEl={this.state.anchorEl} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }} open={open} onClose={this.handleMenuClose} >
              {this.props.serverSettings !== null && this.props.serverSettings.state !== 5 && this.props.userData.role === "normal_user" && <MenuItem onClick={this.onChangeAccountData}>Accountdaten ändern</MenuItem>}
              {this.props.serverSettings !== null && (this.props.userData.role === "normal_user" || this.props.userData.role === "leader") && <MenuItem onClick={this.onChangePassword}>Passwort ändern</MenuItem>}
              {this.props.serverSettings !== null && this.props.userData.role === "normal_user" && <MenuItem onClick={this.onEditReminders}>Erinnerungen einrichten</MenuItem>}
              {this.props.userData.role === "normal_user" && <MenuItem onClick={this.onOpenSharingManagement}>Kinder zuordnen</MenuItem>}
              <MenuItem onClick={this.onSignOut}>Abmelden</MenuItem>
            </Menu>
          </div>)}
        </Toolbar>
      </AppBar>
    );
  }
}

MainAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
  signedIn: PropTypes.bool.isRequired,
  onSignOut: PropTypes.func.isRequired,
  userData: PropTypes.object,
  serverSettings: PropTypes.object.isRequired,
  onChangeAccountData: PropTypes.func.isRequired,
  onChangePassword: PropTypes.func.isRequired,
  onOpenSharingManagement: PropTypes.func.isRequired,
  onEditReminders: PropTypes.func.isRequired,
  onSearchUpdated: PropTypes.func.isRequired,
};

export default withStyles(styles)(MainAppBar);
